import { ReactNode } from 'react';
import { Box, withStyles } from 'vopay';
import styles from './CardRows.module.scss';

type Row = {
  key: string | number;
  left: ReactNode;
  right?: ReactNode;
  visible?: boolean;
};

type ListProps = {
  rows: Row[];
};

const classes = withStyles(styles);

const CardRows: React.FC<ListProps> = ({ rows }) => {
  return (
    <Box flx="col" width="100%" className={classes('rows')}>
      {rows
        .filter(({ visible = true }) => visible)
        .map((row) => (
          <Box key={row.key} jc="sb" ai="fs" className={classes('rowContainer')}>
            <div className={classes('row')}>{row.left}</div>
            {row.right && <div className={classes('row', 'right')}>{row.right}</div>}
          </Box>
        ))}
    </Box>
  );
};

export default CardRows;
